import React from 'react';
import './styles.css';

const InsideFooter = () => {
    return (
        <React.Fragment>
        <hr/>
        <footer>
            <div>
                <p>© 2020 Podcast Chatterbox. All rights reserved.</p>
            </div>
            <div>
                <p>for any bugs or feature requests reach out via <a href='https://twitter.com/room_n'>Twitter</a></p>
            </div>
        </footer>
        </React.Fragment>
    )
}

export default InsideFooter; 